import { PropertySearcherSearchBean } from 'landlord/search/models/search-result.model';
import { ActionState, ActionStateCreator } from '@ui/legacy-lib';
import { PropertySearcherSearchOptions } from 'landlord/search/models/search-options.model';
import { Pagination } from '@ui/shared/models';
import * as fromActions from './search.actions';

export interface SearchPropertySearcherState {
  searchData: PropertySearcherSearchBean[];
  pagination: Pagination;
  searchActionState: ActionState;
  selectedPropertySearcher: PropertySearcherSearchOptions;
}

export const initialState: SearchPropertySearcherState = {
  searchData: [],
  pagination: {},
  selectedPropertySearcher: null,
  searchActionState: ActionStateCreator.create()
};

export function reducer(
  state = initialState,
  action: fromActions.SearchActions
): SearchPropertySearcherState {
  switch (action.type) {
    case fromActions.FETCH_SEARCH_RESULTS: {
      return {
        ...state,
        searchActionState: ActionStateCreator.onStart()
      };
    }

    case fromActions.FETCH_SEARCH_RESULTS_FAIL: {
      return {
        ...state,
        searchActionState: ActionStateCreator.onError(action.error)
      };
    }

    case fromActions.FETCH_SEARCH_RESULTS_SUCCESS: {
      return {
        ...state,
        searchData: action.data,
        pagination: action.page,
        searchActionState: ActionStateCreator.onSuccess()
      };
    }

    case fromActions.SELECT_PROPERTY_SEARCHER: {
      return {
        ...state,
        selectedPropertySearcher: action.data
      };
    }

    default:
      return state;
  }
}

export const getSearchData = (state: SearchPropertySearcherState) =>
  state.searchData;
export const getPagination = (state: SearchPropertySearcherState) =>
  state.pagination;
export const getSelectedPropertySearcher = (
  state: SearchPropertySearcherState
) => state.selectedPropertySearcher;
export const getSearchActionState = (state: SearchPropertySearcherState) =>
  state.searchActionState;
